<template>
  <div class="list-codicearticolo padding-title">
    <div class="sorgente_luminosa_p maiuscoletto_opaco_piccolo">
      <p class="codice_articolo_senza_margin">{{ codicearticolo_title }}</p>
    </div>
    <p style="display:none" class="codice_articolo_value_maiuscoletto">
      {{ codicearticolo_values }}

    </p>
    <p class="codice_articolo_value_maiuscoletto" > {{codicearticolo_alt}} </p>
  </div>
</template>
<script>
import checkLanguage from "../classes/class_check_language";

import is_localhost from "../classes/class_is_localhost";
import Axios from "axios";
export default {
  name: "codicearticolo",
  data() {
    return {
      codicearticolo_values: "",
      codicearticolo_alt:"",
      codicearticolo_v :[]
    };
  },
  methods:{
    get_product(codice_univoco) {
      try {
        
      let details = this.$store.state.products_store.DETAILS;
      let prodotto = details.filter( (detail) =>{
        return detail.id_prodotto == codice_univoco;
      } );

      console.info('paese_seleted prdotto:',  prodotto);
      let p = prodotto[0];
      console.info('paese_seleted prdotto:',  p );

if (prodotto.length > 0){
          let finitura_vetro = p.testo_finitura;
          let finitura_montatura = p.testo_finiturastruttura;
          let modello = p.model;
          let paese = p.PAESE;
          let paese_seleted = 'UL';
          if (paese == 'UL'){ 
             paese_seleted = 'CE';
          }
          let prodotto = details.filter( (detail) =>{
        return detail.testo_finitura == finitura_vetro &&
              detail.testo_finiturastruttura == finitura_montatura &&
              detail.model == modello &&
              detail.PAESE == paese_seleted;
      } );
              


      console.info('paese_seleted F', finitura_vetro, finitura_montatura, modello, paese, paese_seleted, prodotto);

          if (prodotto.lenght >0 ){
            return prodotto;
          }else{
            prodotto = details.filter( (detail) =>{
              return detail.testo_finitura == finitura_vetro &&
              detail.testo_finiturastruttura == finitura_montatura &&
          
              detail.PAESE == paese_seleted;
      } );
       console.info('paese_seleted G' ,  prodotto);
           return prodotto[0];
          }
      }

       } catch (error) {
          console.info('paese_selected H', error)   
      }
     
    },
    setsku(){
            const url = new URL(window.location);
        let params = new URLSearchParams(window.location.search);
        let lang = params.get("lang"); 
          url.searchParams.set( "sku", this.$store.state.product_store.CODICE_UNIVOCO);
        if (lang != null) url.searchParams.set("lang", lang);
            window.history.pushState({}, "", url);
    },
 getCodAlt() {
   let f;

   try {
     
     let codici = this.$store.state.products_store.CODICI;
console.info('select_paese', codici);
     if (typeof codici != "undefined") {
       
       f = codici.filter( (codice) => { 
         return codice.Codice_interno == this.$store.state.product_store.CODICE_UNIVOCO;
    }); 
         console.info('select_paese', f);
       }

    } catch (error) {
      console.info(error);
      console.info('select_paese', error);
      f = [];
    }
    if (typeof f != "undefined") {
      console.info('select_paese', 'A');
      if (f.length == 0){
        console.info('select_paese', 'B');
      let params = new URLSearchParams();
    let ur = new is_localhost();
    let url = ur.return_url_website();
    params.append("action", "getcodalt");
    params.append("V", "getcodalt");
    params.append("ID", this.$store.state.product_store.CODICE_UNIVOCO);
    Axios.post(url + "wp-admin/admin-ajax.php", params)
      .then( (response) => {
        try {
          this.codicearticolo_alt = response.data.Codice_alternativo_att;
          this.codicearticolo_v.push(response.data);
        } catch (error) {
          console.info(error);
          this.codicearticolo_alt = 'error';
        }
      })
      .catch(function (error) {
        console.info(error);
      });
    
    }else{
      this.codicearticolo_alt = f[0].Codice_alternativo_att;

    }
    }
    

  
  }

  },
  mounted() {
    
    this.$store.subscribe((mutation) => {
        if (mutation.type == "add_codice_alt") {
          this.codicearticolo_alt = this.$store.state.codalt;
        }
        if (mutation.type == "click_on_modello") {
           this.getCodAlt();
        }
        if (mutation.type == "click_on_montatura") {
                this.getCodAlt();
        }
        if (mutation.type == "click_on_vetro") {
                this.getCodAlt();
        }
        if (mutation.type == "select_product_by_id") {
                this.getCodAlt();
                this.setsku();
        }
        if (mutation.type == "selected_paese") {
                this.getCodAlt();
        }
        if (mutation.type == "change_id_prodotto") {
        this.codicearticolo_values =
        this.$store.state.product_store.CODICE_UNIVOCO;
        this.getCodAlt();
        if (this.$store.state.product_store.CODICE_UNIVOCO != "") {
          this.$store.commit("get_documents");
          this.$store.commit("new_product_link_search");
        }
        const url = new URL(window.location);
        let params = new URLSearchParams(window.location.search);
        let lang = params.get("lang"); // is the string "Jonathan"
        url.searchParams.set(  "sku",  this.$store.state.product_store.CODICE_UNIVOCO);
        if (lang != null) url.searchParams.set("lang", lang);
          this.getCodAlt();
          window.history.pushState({}, "", url);
        }
        if (mutation.type == "get_modelli_to_display_from_vetro_and_montatura") {
// QUESTA FUNZIONE NON FA ALTRO CHE AGGIUNGERE ALL'URL I PARAMETRI DEL CODICE UNIVOCO

          this.codicearticolo_values =
          this.$store.state.product_store.CODICE_UNIVOCO;
        if (this.$store.state.product_store.CODICE_UNIVOCO != "") {
          this.$store.commit("get_documents");
          this.$store.commit("new_product_link_search");
        }
        const url = new URL(window.location);
        let params = new URLSearchParams(window.location.search);
        let lang = params.get("lang"); // is the string "Jonathan"
        url.searchParams.set(
          "sku",
          this.$store.state.product_store.CODICE_UNIVOCO
        );
        if (lang != null) url.searchParams.set("lang", lang);
        window.history.pushState({}, "", url);
      }

      if (mutation.type == "selected_paese") {
              console.info('select_paese', 'C');
        let codice_univoco =
        this.$store.state.product_store.CODICE_UNIVOCO;
        console.info('mutation selected paese aftrer codice univico:', codice_univoco);
        // filtra i prodotti e trova quello specifico...
        let  prodotto = this.get_product(codice_univoco);

              console.info('select_paese', 'D');
        this.getCodAlt();
        let paese = "UL";
              console.info('select_paese', 'E');
        if (this.$store.state.paese == "EU") {
          paese = "CE";
        }
        console.log('paese', paese);
          console.info('select_paese', this.$store.paese);
        codice_univoco = prodotto.id_prodotto;
          console.info('select_paese', codice_univoco);
        this.codicearticolo_values = codice_univoco;
          console.info('select_paese', this.codicearticolo_values);
        if (this.$store.state.product_store.CODICE_UNIVOCO != "") {
          this.$store.commit("get_documents");
          this.$store.commit("new_product_link_search");
        }
          console.info('select_paese', this.$store.state.product_store.CODICE_UNIVOCO);
        const url = new URL(window.location);
        let params = new URLSearchParams(window.location.search);
        let lang = params.get("lang"); // is the string "Jonathan"
        url.searchParams.set(  "sku",  this.$store.state.product_store.CODICE_UNIVOCO);
        if (lang != null) url.searchParams.set("lang", lang);
        window.history.pushState({}, "", url);
        }
    });
  },
  computed: {
    codicearticolo_value_222() {
      if (this.$store.state.product_store.CODICE_UNIVOCO != "") {
        this.$store.commit("get_documents");
        this.$store.commit("new_product_link_search");
      }
      const url = new URL(window.location);
      let params = new URLSearchParams(window.location.search);
      let lang = params.get("lang"); // is the string "Jonathan"
      url.searchParams.set(  "sku",  this.$store.state.product_store.CODICE_UNIVOCO);
      if (lang != null) url.searchParams.set("lang", lang);
      window.history.pushState({}, "", url);
      return this.$store.state.product_store.CODICE_UNIVOCO;
    },
    codicearticolo_title() {
      let i = new checkLanguage();
      if (i.is_italian()) {
        let language = this.$store.state.product.language;
        return this.$store.state[language].codicearticolo;
      } else {
        return "ITEM NUMBER";
      }
    },
  },
};
</script>

<style>
.codice_articolo_senza_margin {
  margin-bottom: 0px !important;
}
</style>
